import type { ReactNode } from "react";

interface FeatureCardProps {
  icon: string;
  title: string;
  /** Points concrets (une ligne chacun, coche devant). */
  items?: string[];
  children?: ReactNode;
  /** Carte mise en avant : pastille foncée, légère élévation. */
  highlight?: boolean;
  className?: string;
}

/** Carte du site public : icône dans une pastille, titre, texte ou liste cochée. */
export default function FeatureCard({ icon, title, items, children, highlight, className = "" }: FeatureCardProps) {
  return (
    <div
      className={`h-full rounded-[1.5rem] border bg-white p-6 transition-shadow duration-200 hover:shadow-raised md:p-7 ${
        highlight ? "border-primary-200 shadow-raised" : "border-background-200"
      } ${className}`}
    >
      <span
        className={`flex h-12 w-12 items-center justify-center rounded-xl ${
          highlight ? "bg-primary-950 text-white" : "bg-background-100 text-primary-800"
        }`}
        aria-hidden="true"
      >
        <i className={`${icon} text-xl`}></i>
      </span>
      <h3 className="mt-5 text-lg font-bold font-heading text-foreground-950">{title}</h3>
      {children && <div className="mt-2 text-[0.95rem] leading-relaxed text-foreground-600">{children}</div>}
      {items && (
        <ul className="mt-4 space-y-2.5">
          {items.map((item) => (
            <li key={item} className="flex gap-2.5 text-[0.95rem] leading-snug text-foreground-700">
              <i className="ri-check-line mt-0.5 shrink-0 text-primary-600" aria-hidden="true"></i>
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
